import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { formatDataTestId } from '@whitbread-eos/utils';
import { useEffect, useState } from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function SwitchToggle(_ref) {
  var onToggle = _ref.onToggle,
    first = _ref.first,
    second = _ref.second,
    _ref$defaultSelected = _ref.defaultSelected,
    defaultSelected = _ref$defaultSelected === void 0 ? true : _ref$defaultSelected,
    baseDataTestId = _ref.baseDataTestId,
    fontSize = _ref.fontSize;
  var _useState = useState(defaultSelected),
    _useState2 = _slicedToArray(_useState, 2),
    firstSelected = _useState2[0],
    setFirstSelected = _useState2[1];
  useEffect(() => {
    if (firstSelected != defaultSelected) {
      setFirstSelected(defaultSelected);
    }
  }, [defaultSelected]);
  var handleToggle = () => {
    setFirstSelected(prev => !prev);
    onToggle(!firstSelected);
  };
  var handleKeyUp = event => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleToggle();
    }
  };
  return _jsxs("div", {
    role: "switch",
    tabIndex: 0,
    "aria-checked": firstSelected,
    onClick: handleToggle,
    onKeyUp: handleKeyUp,
    style: styles.switchToggle,
    "data-testid": formatDataTestId(baseDataTestId, 'SwitchToggle'),
    children: [_jsx("span", {
      "data-testid": formatDataTestId(baseDataTestId, 'first'),
      style: _objectSpread(_objectSpread(_objectSpread({}, styles.option), fontSize && {
        fontSize
      }), firstSelected ? styles.selected : {}),
      children: first
    }), _jsx("span", {
      "data-testid": formatDataTestId(baseDataTestId, 'second'),
      style: _objectSpread(_objectSpread(_objectSpread({}, styles.option), fontSize && {
        fontSize
      }), !firstSelected ? styles.selected : {}),
      children: second
    })]
  });
}
var styles = {
  switchToggle: {
    height: '2.625rem',
    border: '1px solid #cccccc',
    borderRadius: '2.625rem',
    display: 'inline-flex',
    justifyContent: 'space-between',
    padding: '0.188rem',
    cursor: 'pointer',
    userSelect: 'none'
  },
  option: {
    lineHeight: '2.1rem',
    display: 'inline-block',
    textAlign: 'center',
    flexGrow: 1,
    padding: '0 0.875rem'
  },
  selected: {
    backgroundColor: '#00798e',
    borderRadius: '2rem',
    color: '#ffffff'
  }
};